














import { Vue, Component, Prop } from 'vue-property-decorator';
import { mdbRow, mdbCol, mdbInput, mdbAlert, mdbIcon } from '@folky-tools/mdbvue';
import { PaymentOnHandingOver } from '@/models/common/payment-on-handing-over';

@Component({
    components: {
        mdbRow,
        mdbCol,
        mdbInput,
        mdbAlert,
        mdbIcon
    }
})
export default class EditPaymentOnDeliveryConfig extends Vue {
    @Prop(PaymentOnHandingOver) private paymentOnHandingOver!: PaymentOnHandingOver;
}
